import { Component, OnInit } from '@angular/core';
import {ConnecttocrudService} from "../connecttocrud.service";
import 'src/assets/js/permissionGroup';
import {MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ConfService} from '../conf.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

declare let $;
@Component({
  selector: 'app-permission-groups',
  templateUrl: './permission-groups.component.html',
  styleUrls: ['./permission-groups.component.css']
})
export class PermissionGroupsComponent implements OnInit {
  permissions: any;
  orgchart: any;
  error: boolean;
  items: any;
  columns: any;
  itemList: any;
  options: any;
  errorMessage: string;
  searchText: any;
  itemLength: any;
  partnerShortCode: any;
  account: any;
  filterData: any[];
  operation: string;
  settings = {text: 'Select attribute(s) to search instantly'};
  userView = 'table';
  create = false;
  entity = 'Manage Permission Groups';
  getPermissionGroupName: string;
  rightPanel = true;
  permissionGroups: any;
  constructor(private _service: ConnecttocrudService, public platform: LeftpanelComponent, private dialog: MatDialog, private confPost: ConfService) { }

  ngOnInit() {
    this.error = false;
    $('.visual-editor').hide();
    this.account = localStorage.getItem('partner').split('-');
    this.partnerShortCode = this.account[this.account.length - 1];
    let envArray = '';
    this.confPost.getSettingsCRUD(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        for (let i = 0; i < data[0].environments.length; i++ ) {
          if (envArray !== '') {
            envArray = envArray + ',' + data[0].environments[i]['type'] + '-' + this.partnerShortCode;
          } else {
            envArray = envArray + data[0].environments[i]['type'] + '-' + this.partnerShortCode;
          }
        }
        this._service.getPermissionGroupswithParams(localStorage.getItem('partner'), localStorage.getItem('account'), envArray). subscribe(res => {
            this.permissionGroups = res;
        });
    });
    this._service.getPermissionGroups(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(
        items => {
          this.items = items;
          // this.itemLength = this.items.length;
          for (const item of this.items) {
            this.columns = [];
            for (const itemval in item) {
              this.columns.push(itemval);
            }
          }
          this.itemList = [];
          if (this.columns) {
            for (let t = 0; t < this.columns.length; t++) {
              const tempObj = {};
              tempObj['id'] = t;
              tempObj['permissionGroup'] = this.columns[t];
              this.itemList.push(tempObj);
            }
          }

          this.options = {
            fieldSeparator: ',',
            quoteStrings: '',
            decimalseparator: '.',
            headers: this.columns,
            showTitle: false,
            useBom: true,
            noDownload: false,
            nullToEmptyString: true,
            removeNewLines: false,
            keys: []
          };
        },
        error => {
          this.error = true;
          this.errorMessage = (error.error.message ? error.error.message : error.error);
        }
    );

    // this._service.getPermissions(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
    //   this.permissions = data;
    //   /*this._service.getItems('v1', localStorage.getItem('partner'), localStorage.getItem('account'), 'PermissionGroups').subscribe( data1 => {
    //
    //     this.loadChart(data1[0]);
    //   });*/
    // });

    var that = this;
    $(document).on('click', '.createNode', function() {
      that.create = false;
      that.operation = 'create';
      var newNode = {'permissionGroup': that.getPermissionGroupName, 'id': that.getId()};
      that.loadChart(newNode);
      that.rightPanel = true;
      that.getPermissionGroupName = null;
    });
  }

  loadChart(datascource) {
    var that = this;
    $('.permissionSection').html('');
    $('#chart-container').html('');
    $('.deleteNode').html('');
    $('#saveChanges').remove();
    $(function() {
      that.orgchart = $('#chart-container').orgchart({
        'data' : datascource,
        'nodeContent': 'title',
        'partner': localStorage.getItem('partner'),
        'account': localStorage.getItem('account'),
        'pkey': localStorage.getItem('partnerKey'),
        'draggable': true,
        'dropCriteria': function($draggedNode, $dragZone, $dropZone) {
          if($draggedNode.find('.content').text().indexOf('manager') > -1 && $dropZone.find('.content').text().indexOf('engineer') > -1) {
            return false;
          }
          return true;
        }
      });
      var oc = that.orgchart;
      oc.$chart.on('nodedrop.orgchart', function(event, extraParams) {

      });

      that.permissions.forEach((data) => {
        data.level = 2;
        data.parentId = 2;
        const nodeData = $.extend({}, data);
        const $nodediv = $('<td colspan="2" style="display: grid;" class="drag-panel"><table><tr><td>' +
            '<div class="node permission-drag-panel" data-parent="2" draggable="true">' +
            '<div class="title" style="word-break: break-word;padding: 3px;" id= "' + data.id + '" title="' + data.partner + '.' + data.account + '">' +
            data.permission + '</div></div>' +
            '</td></tr></table></td>'
        );
        $nodediv.data('nodeData', nodeData);

        oc.bindDragDrop($nodediv);
        $('.permissionSection').append($nodediv);
      });
      const $savebtn = $('<button _ngcontent-c5="" id="saveChanges" class="confap-button mat-stroked-button" mat-stroked-button=""><span class="mat-button-wrapper"> Save </span><div class="mat-button-ripple mat-ripple" matripple="" ng-reflect-centered="false" ng-reflect-disabled="false" ng-reflect-trigger="[object HTMLButtonElement]"></div><div class="mat-button-focus-overlay"></div></button>');
      $savebtn.click(function () {
        that.updatePermissionGroup(oc.getHierarchy('permissiongroups'));
        //  that.addDataType(event1);
      });
      $('.chart-contain').append($savebtn);
      /*$(document).on('click', '#saveChanges', function () {
        that.updatePermissionGroup(oc.getHierarchy('permissionGroup'));
      });*/
      const $node = $('<i class="fa fa-trash"  style="float: initial;font-size: 25px;color:#505050"></i>');
      oc.bindRemoveDrop($node);
      $node.addClass('allowedDrop');
      $('.deleteNode').append($node);
      $(document).on('keyup', '.filterText', function(){
        oc.searchFilter();
      });
      $(document).on('click', '.cancelNode', function() {
        that.create = false;
        $('.table-responsive').attr('class', 'table-responsive col-md-12');
        $('.visual-editor').hide();
        //   that.loadChartById(datascource);
      });
    });
  }
  typeOfval(val) {
    return typeof val;
  }
  addNewGroup() {
    const dialogRef = this.dialog.open(AddNewPermissionComponent, {
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res !== undefined) {
        this._service.InsertPermissionGroup(localStorage.getItem('partner'), localStorage.getItem('account'), res). subscribe (res => {
          alert('Insertion Successful.');
          this.permissionGroups.push(res);
            }, err => {
          alert('Insertion Unsuccessful. Please try again later.');
        });
      }
    });
  }
  stringifyjson(val) {
    return JSON.stringify(val, null, 2).trim();
  }
  getPermissionGroup(id) {
    this.create = false;
    $('.table-responsive').attr('class', 'table-responsive col-md-2');
    $('.visual-editor').show();
    this.operation = 'update';
    this._service.getPermissionGroup(localStorage.getItem('partner'), localStorage.getItem('account'), id).subscribe(data => {
      this.loadChart(data);
    });
  }
  updatePermissionGroup(data) {
    data.partner = localStorage.getItem('partner');
    data.account = localStorage.getItem('account');
    if (this.operation == 'update') {
      this._service.UpdatePermissionGroup(localStorage.getItem('partner'),
          localStorage.getItem('account'), data).subscribe(data => {
        this.platform.openSnackBar('Updated successfully', 'Success', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    } else {
      delete data.id;
      this._service.InsertPermissionGroup(localStorage.getItem('partner'),
          localStorage.getItem('account'), data).subscribe(data => {
        this.platform.openSnackBar('Created successfully', 'Success', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }

  }
  createPermissionGroup() {
    $('.table-responsive').attr('class', 'table-responsive col-md-2');
    $('.visual-editor').show();
    this.operation = 'create';
    this.rightPanel = false;
    this.create = true;
  }

  getId() {
    return (new Date().getTime()) * 1000 + Math.floor(Math.random() * 1001);
  }
  deleteRecord(id) {
    if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
      this._service.deletePermissionGroup(localStorage.getItem('partner'), localStorage.getItem('account'), id).subscribe(
          agents => {
            alert('Deletion Succesfull');
            const itemDuplicate = this.permissionGroups;
            const deleteditem =  itemDuplicate.findIndex(p => p && p.id === id);
            delete this.permissionGroups[deleteditem];
          },
          error => {

          }
      );
    } else {
    }
  }

}

@Component({
  selector: 'app-addNewPermission',
  templateUrl: './addNewPermission.component.html',
  styleUrls: ['./addNewPermission.component.scss']
})
export class AddNewPermissionComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<AddNewPermissionComponent>) {
  }
  schema = {
    'permissionGroup': '',
    'permissions': [],
    'partner': '',
    'account': ''
  };
  parameters = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  ngOnInit(): void {
  }
  remove(val, data): void {
    const index = this.schema.permissions.indexOf(val);
    this.schema.permissions.splice(val, 1);
  }
  addPermission() {
    if (this.schema.partner !== '' && this.schema.account !== '' && this.schema.permissionGroup !== '' && this.schema.permissions.length > 0) {
      this.dialogRef.close(this.schema);
    } else {
      alert('Please enter all required fields before proceeding');
    }

  }
  add(event, data): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.schema.permissions.push(value.trim());
    }

    if (input) {
      input.value = '';
    }
  }
}
